module.exports = __webpack_public_path__ + "static/img/videobg.d8da84b.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/life/videobg.jpg
// module id = dhFQ
// module chunks = 1